import React from "react";
import { IFieldArrayValidation } from "../../interfaces/Components/ErrorMessagesFieldArray/IFieldArrayValidation";

export const ErrorMessagesFieldArray = ({ collection, fieldName, index, errors } : IFieldArrayValidation) => {

    let content = null;
    if (errors && errors[collection] && errors[collection][index] && errors[collection][index][fieldName]) {
        content = 

            <div data-testid={`validationError.${collection}.${index}.${fieldName}`} className="validation-error">
                {errors[collection][index][fieldName].message}
            </div>;
    }

    return (
        <>{content}</>
    );
}
